<template>
    <v-container grid-list-md fluid>
        <v-layout row justify-space-between align-center class="mb-3">
            <div class="display-1">{{$t('generalStatistic') | capitalize}}</div>
            <v-layout row wrap justify-start class="pl-5">
                <span class="mr-3">
                    <v-checkbox
                        v-model="user"
                        :label="$filters.capitalize($t('user'))"
                    ></v-checkbox>
                </span>
                <span class="mr-3">
                    <v-checkbox
                        v-model="activeUser"
                        :label="$filters.capitalize($t('topApiCallByUser'))"
                    ></v-checkbox>
                </span>
                <span class="mr-3">
                    <v-checkbox
                        v-model="api"
                        :label="$filters.capitalize($t('api'))"
                    ></v-checkbox>
                </span>
                <span class="mr-3">
                    <v-checkbox
                        v-model="activeProject"
                        :label="$filters.capitalize($t('topApiCallByProject'))"
                    ></v-checkbox>
                </span>
            </v-layout>
            <v-btn color="primary" @click="exportReport">{{this.$t('exportReport')}}</v-btn>
        </v-layout>
        <v-layout row wrap fill-height>
            <v-flex md12 lg6 v-if="user">
                <UserGeneral style="height: 100%"></UserGeneral>
            </v-flex>
            <v-flex md12 lg6 v-if="activeUser">
                <TopActiveUsers ref="TopActiveUsers" style="height: 100%"></TopActiveUsers>
            </v-flex>
            <v-flex md12 lg6 v-if="api">
                <ApiGeneral style="height: 100%"></ApiGeneral>
            </v-flex>
            <v-flex md12 lg6 v-if="activeProject">
                <TopActiveProjects ref="TopActiveProjects" style="height: 100%"></TopActiveProjects>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
import TopActiveUsers from './General/TopActiveUsers'
import UserGeneral from './General/UserGeneral'
import TopActiveProjects from './General/TopActiveProjects'
import ApiGeneral from './General/ApiGeneral'
import Excel from 'exceljs'

export default {
    name: 'GeneralAnalytics',
    components: {
        TopActiveUsers,
        UserGeneral,
        TopActiveProjects,
        ApiGeneral
    },
    data () {
        return {
            user: true,
            activeUser: true,
            activeProject: true,
            api: true
        }
    },
    methods: {
        exportReport () {
            if (!this.$refs.TopActiveUsers) {
                this.$appService.toastError(this.$t('turnOnToCreateReport', [this.$t('topApiCallByUser')]))
                return
            }
            if (!this.$refs.TopActiveProjects) {
                this.$appService.toastError(this.$t('turnOnToCreateReport', [this.$t('topApiCallByProject')]))
                return
            }
            let workbook = new Excel.Workbook()
            this.$refs.TopActiveUsers.addWorkSheet(workbook)
            this.$refs.TopActiveProjects.addWorkSheet(workbook)
            workbook.xlsx.writeBuffer().then((data) => {
                this.$utils.downloadFileFromBlob(data, this.$t('user') + ' and ' + this.$t('project') + '.xlsx')
            })
        }
    }
}
</script>
